import { useEffect, useState } from 'react';

/**
 * Single mobile breakpoint shared across the app. Anything below this width
 * gets the compact layout (off-canvas sidebar, stacked grids, full-width drawers).
 */
export const MOBILE_BREAKPOINT = 768;

/**
 * Track viewport width against the mobile breakpoint. SSR-safe (returns
 * `false` until `window` is available) and listens for resize events.
 */
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT): boolean {
  const initial = typeof window !== 'undefined' && window.innerWidth < breakpoint;
  const [isMobile, setIsMobile] = useState<boolean>(initial);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
